/**
 * @generated SignedSource<<bd734f19f5b2931a031e7c5b2e67da0b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StatsPanel_note$data = {
  readonly account: {
    readonly allowRecapEngagementStats: boolean;
  };
  readonly eventEnd: string | null;
  readonly eventStart: string | null;
  readonly " $fragmentType": "StatsPanel_note";
};
export type StatsPanel_note$key = {
  readonly " $data"?: StatsPanel_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"StatsPanel_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StatsPanel_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventEnd",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowRecapEngagementStats",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};

(node as any).hash = "a3ae5e68e9ae24ae84c952df85f52d6a";

export default node;
